import cn from 'classnames';

import { IConDefaultType } from '../types';

export enum LockIconVariant {
  DEFAULT = 'default',
  UNLOCK = 'unlock',
  SMALL = 'small',
  FILL = 'fill',
  GALLERY = 'gallery',
}

export interface ILockIconProps extends IConDefaultType {
  variant?: LockIconVariant;
}

function LockIcon({
  color = '#303037',
  className,
  size = 16,
  rotate,
  flip,
  variant = LockIconVariant.DEFAULT,
  style,
}: ILockIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      {variant === LockIconVariant.DEFAULT && (
        <svg viewBox="0 0 16.6666 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M14.1666 7.02V5.83332C14.1666 2.61168 11.555 0 8.33332 0C5.11164 0 2.5 2.61168 2.5 5.83332V7.02C0.983359 7.68191 0.0021875 9.17856 0 10.8333V15.8333C0.00273438 18.1334 1.8666 19.9973 4.16664 20H12.5C14.8 19.9973 16.6639 18.1334 16.6666 15.8333V10.8333C16.6645 9.17856 15.6833 7.68191 14.1666 7.02ZM9.16664 14.1667C9.16664 14.6269 8.79355 15 8.33332 15C7.87309 15 7.5 14.6269 7.5 14.1667V12.5C7.5 12.0398 7.87309 11.6667 8.33332 11.6667C8.79355 11.6667 9.16664 12.0398 9.16664 12.5V14.1667V14.1667ZM12.5 6.66668H4.16664V5.83336C4.16664 3.53219 6.03211 1.66668 8.33332 1.66668C10.6345 1.66668 12.5 3.53215 12.5 5.83336V6.66668V6.66668Z"
            fill={color}
          />
        </svg>
      )}
      {variant === LockIconVariant.UNLOCK && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.665 20" fill="none">
          <path
            d="M12.4988 6.66796H4.16626V5.83471C4.166 4.91097 4.47275 4.01334 5.03827 3.28294C5.60379 2.55254 6.39602 2.0308 7.2904 1.79974C8.18477 1.56868 9.13058 1.64141 9.97912 2.00649C10.8277 2.37157 11.5308 3.0083 11.978 3.81658C12.0311 3.91227 12.1026 3.99656 12.1883 4.06464C12.274 4.13271 12.3723 4.18324 12.4775 4.21334C12.5827 4.24344 12.6928 4.25252 12.8016 4.24006C12.9103 4.22759 13.0155 4.19384 13.1112 4.14071C13.2069 4.08759 13.2912 4.01613 13.3593 3.93043C13.4274 3.84473 13.4779 3.74646 13.508 3.64123C13.5381 3.536 13.5472 3.42587 13.5347 3.31714C13.5222 3.2084 13.4885 3.10318 13.4354 3.00749C12.809 1.87619 11.8245 0.985118 10.6365 0.474329C9.44853 -0.0364591 8.12451 -0.137997 6.87256 0.185676C5.6206 0.509349 4.5117 1.23988 3.72016 2.26244C2.92862 3.28499 2.49933 4.54159 2.49976 5.83471V7.02126C1.75763 7.34515 1.12597 7.87828 0.682016 8.55546C0.238065 9.23263 0.00106521 10.0245 0 10.8342V15.8337C0.00132309 16.9383 0.440692 17.9972 1.22173 18.7783C2.00277 19.5593 3.06171 19.9987 4.16626 20H12.4988C13.6033 19.9987 14.6623 19.5593 15.4433 18.7783C16.2244 17.9972 16.6637 16.9383 16.665 15.8337V10.8342C16.6637 9.72967 16.2244 8.67073 15.4433 7.8897C14.6623 7.10866 13.6033 6.66929 12.4988 6.66796V6.66796ZM14.9985 15.8337C14.9985 16.4967 14.7352 17.1325 14.2664 17.6013C13.7976 18.0701 13.1618 18.3335 12.4988 18.3335H4.16626C3.50328 18.3335 2.86746 18.0701 2.39867 17.6013C1.92987 17.1325 1.6665 16.4967 1.6665 15.8337V10.8342C1.6665 10.1712 1.92987 9.53543 2.39867 9.06663C2.86746 8.59783 3.50328 8.33447 4.16626 8.33447H12.4988C13.1618 8.33447 13.7976 8.59783 14.2664 9.06663C14.7352 9.53543 14.9985 10.1712 14.9985 10.8342V15.8337Z"
            fill={color}
          />
          <path
            d="M8.33256 11.6672C8.11156 11.6672 7.89962 11.755 7.74336 11.9113C7.58709 12.0675 7.4993 12.2795 7.4993 12.5004V14.167C7.4993 14.3879 7.58709 14.5999 7.74336 14.7561C7.89962 14.9124 8.11156 15.0002 8.33256 15.0002C8.55355 15.0002 8.76549 14.9124 8.92176 14.7561C9.07803 14.5999 9.16582 14.3879 9.16582 14.167V12.5004C9.16582 12.2795 9.07803 12.0675 8.92176 11.9113C8.76549 11.755 8.55355 11.6672 8.33256 11.6672Z"
            fill={color}
          />
        </svg>
      )}
      {variant === LockIconVariant.SMALL && (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.5 4.212V3.5C9.5 2.57174 9.13125 1.6815 8.47487 1.02513C7.8185 0.368749 6.92826 0 6 0C5.07174 0 4.1815 0.368749 3.52513 1.02513C2.86875 1.6815 2.5 2.57174 2.5 3.5V4.212C2.05468 4.40635 1.67565 4.72626 1.40925 5.13261C1.14285 5.53895 1.00064 6.01412 1 6.5V9.5C1.00079 10.1628 1.26444 10.7982 1.73311 11.2669C2.20178 11.7356 2.8372 11.9992 3.5 12H8.5C9.1628 11.9992 9.79822 11.7356 10.2669 11.2669C10.7356 10.7982 10.9992 10.1628 11 9.5V6.5C10.9994 6.01412 10.8571 5.53895 10.5908 5.13261C10.3244 4.72626 9.94532 4.40635 9.5 4.212ZM3.5 3.5C3.5 2.83696 3.76339 2.20107 4.23223 1.73223C4.70107 1.26339 5.33696 1 6 1C6.66304 1 7.29893 1.26339 7.76777 1.73223C8.23661 2.20107 8.5 2.83696 8.5 3.5V4H3.5V3.5ZM10 9.5C10 9.89782 9.84196 10.2794 9.56066 10.5607C9.27936 10.842 8.89782 11 8.5 11H3.5C3.10218 11 2.72064 10.842 2.43934 10.5607C2.15804 10.2794 2 9.89782 2 9.5V6.5C2 6.10218 2.15804 5.72064 2.43934 5.43934C2.72064 5.15804 3.10218 5 3.5 5H8.5C8.89782 5 9.27936 5.15804 9.56066 5.43934C9.84196 5.72064 10 6.10218 10 6.5V9.5Z"
            fill={color}
          />
          <path
            d="M6 7C5.86739 7 5.74022 7.05268 5.64645 7.14645C5.55268 7.24021 5.5 7.36739 5.5 7.5V8.5C5.5 8.63261 5.55268 8.75978 5.64645 8.85355C5.74022 8.94732 5.86739 9 6 9C6.13261 9 6.25979 8.94732 6.35356 8.85355C6.44733 8.75978 6.50001 8.63261 6.50001 8.5V7.5C6.50001 7.36739 6.44733 7.24021 6.35356 7.14645C6.25979 7.05268 6.13261 7 6 7Z"
            fill={color}
          />
        </svg>
      )}
      {variant === LockIconVariant.FILL && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 18" fill="none">
          <path
            d="M14.2958 6.5866V5.62539C14.2958 3.01585 12.1804 0.900391 9.5708 0.900391C6.96124 0.900391 4.8458 3.01585 4.8458 5.62539V6.5866C3.61732 7.12275 2.82257 8.33503 2.8208 9.67539V13.7254C2.82302 15.5884 4.33275 17.0982 6.19578 17.1004H12.9458C14.8088 17.0982 16.3186 15.5884 16.3208 13.7254V9.67539C16.3191 8.33503 15.5243 7.12275 14.2958 6.5866ZM10.2458 12.3754C10.2458 12.7482 9.94359 13.0504 9.5708 13.0504C9.19801 13.0504 8.89581 12.7482 8.89581 12.3754V11.0254C8.89581 10.6526 9.19801 10.3504 9.5708 10.3504C9.94359 10.3504 10.2458 10.6526 10.2458 11.0254V12.3754ZM12.9458 6.30041H6.19578V5.62542C6.19578 3.76147 7.70682 2.2504 9.5708 2.2504C11.4348 2.2504 12.9458 3.76144 12.9458 5.62542V6.30041Z"
            fill={color || 'white'}
          />
        </svg>
      )}
      {variant === LockIconVariant.GALLERY && (
        <svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.273438" width="24" height="24" rx="12" fill="black" fillOpacity="0.6" />
          <g clipPath="url(#clip0_1389_56776)">
            <path
              d="M16 10.4854V9.77343C16 7.84045 14.433 6.27344 12.5 6.27344C10.567 6.27344 9 7.84045 9 9.77343V10.4854C8.09002 10.8826 7.50131 11.7806 7.5 12.7734V15.7734C7.50164 17.1535 8.61996 18.2718 9.99998 18.2734H15C16.38 18.2718 17.4983 17.1535 17.5 15.7734V12.7734C17.4987 11.7806 16.91 10.8826 16 10.4854ZM13 14.7734C13 15.0496 12.7761 15.2734 12.5 15.2734C12.2239 15.2734 12 15.0496 12 14.7734V13.7734C12 13.4973 12.2239 13.2734 12.5 13.2734C12.7761 13.2734 13 13.4973 13 13.7734V14.7734ZM15 10.2734H9.99998V9.77345C9.99998 8.39275 11.1193 7.27345 12.5 7.27345C13.8807 7.27345 15 8.39273 15 9.77345V10.2734Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1389_56776">
              <rect width="12" height="12" fill="white" transform="translate(6.5 6.27344)" />
            </clipPath>
          </defs>
        </svg>
      )}
    </i>
  );
}

export default LockIcon;
